import React from "react";
import { DateTime } from "luxon";
import { amountFormatter } from "services";
import { CheckCircle, Landmark } from "lucide-react";

export default function PropertyDetailCardWithoutTypesense(props: any) {
  const handleClick = () => {
    window.open(`/auction-properties/${props.property?.listing_id}`, "_blank");
  };

  return (
    <div
      key={props.property?.uuid}
      className={`relative bg-white border border-gray-200 shadow-sm flex flex-col ${props.borderClasses} ${props.widthClasses} hover:shadow-lg transition-shadow duration-300 cursor-pointer`}
      onClick={handleClick}
    >
      <div className="flex-1 flex flex-col">
        {!props.top && (
          <div className="text-left px-4 py-2 border-b text-xs text-gray-500">
            Assets ID: {props?.property?.listing_id}
          </div>
        )}

        <div className="text-left py-3 px-4 border-b">
          <h2 className="font-semibold text-gray-800 text-md mb-1 overflow-x-auto scrollbar-hide">
            <span className="inline-flex items-center whitespace-nowrap min-w-min">
              <span className="text-blue-600 capitalize">
                {props?.property?.sub_asset_type?.name}
              </span>
            </span>
          </h2>
          <p className="text-xs text-gray-600 capitalize">
            {props?.property?.city?.name}, {props?.property?.state?.name}
          </p>
        </div>

        <div className="flex-grow flex flex-col justify-between">
          <div className="text-left border-b border-dotted px-4 py-3 flex justify-between items-center">
            <div className="flex flex-col">
              <div className="text-xs text-gray-500 mb-1">Reserve Price</div>
              <div className="text-lg font-bold text-blue-600">
                {props?.property?.property_date_type === "undated" ? (
                  <div className="cursor-pointer hover:text-blue-700">
                    Contact Us
                  </div>
                ) : (
                  `₹${amountFormatter(props?.property?.reserve_price)}`
                )}
              </div>
            </div>
            <div className="flex flex-col items-end">
              <div className="text-xs text-gray-500 mb-1">Auction Date</div>
              <div className="text-sm font-medium text-right">
                {props.property.property_date_type === "undated" ? (
                  <span className="text-red-600">Coming Soon</span>
                ) : props.property.property_date_type === "private_treaty" ? (
                  <span className="text-green-600">Private Treaty</span>
                ) : (
                  <div>
                    {props.property?.auction_start_date_time && (
                      <div>
                        {DateTime.fromISO(props.property?.auction_start_date_time)
                          .setZone("Asia/Kolkata")
                          .toFormat("dd MMM yyyy")}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="text-left px-4 py-3 flex justify-between items-center overflow-x-auto scrollbar-none">
  <div className="flex items-center justify-between text-xs text-gray-600 capitalize truncate" style={{ flex: '4' }}>
  {props.property?.bank?.name && (
  <div className="flex items-center">
    <Landmark className="w-4 h-4 mr-2 text-gray-600 flex-shrink-0" />
    <span className="text-xs">
      {props.property?.bank?.name.length > 20
        ? props.property?.bank?.name.slice(0, 20) + '...'
        : props.property?.bank?.name}
    </span>
  </div>
)}
  </div>
  {props?.property?.ab_verified && (
    <div className="text-sm flex items-center justify-center text-green-600" style={{ flex: '1', marginLeft: 'auto' }}>
      <CheckCircle className="w-4 h-4" />
    </div>
  )}
</div>
        </div>
      </div>
    </div>
  );
}